import React from 'react';
import './Benefits.css';
import useScrollReveal from '../hooks/useScrollReveal';
import useSpotlight from '../hooks/useSpotlight';
import useTilt from '../hooks/useTilt';
import SectionCTA from './SectionCTA';

const benefits = [
  {
    num: '01',
    title: 'Increased Productivity',
    desc: 'Automate repetitive execution so your team stays focused on strategy—not sorting through tasks.',
  },
  {
    num: '02',
    title: 'Cost Reduction',
    desc: 'Cut operational costs by eliminating manual work and optimizing resource allocation for better profitability.',
  },
  {
    num: '03',
    title: '24/7 Availability',
    desc: 'AI-powered systems operate around the clock, ensuring seamless support and execution without downtime.',
  },
  {
    num: '04',
    title: 'Data-Driven Insights',
    desc: 'Leverage AI to analyze vast data sets, identify trends, and make smarter, faster business decisions.',
  },
  {
    num: '05',
    title: 'Better Customer Experience',
    desc: 'Personalized AI interactions improve response times, engagement, and overall satisfaction.',
  },
  {
    num: '06',
    title: 'Scalability & Growth',
    desc: 'AI adapts to your business needs—scale efficiently without increasing workload or headcount.',
  },
];

export default function Benefits() {
  const headerRef = useScrollReveal();
  const gridRef = useScrollReveal({ threshold: 0.08 });
  useSpotlight('.benefit-card');
  useTilt('.benefit-card');

  return (
    <section className="benefits" id="benefits">
      <div className="benefits-inner">
        <div className="benefits-header reveal" ref={headerRef}>
          <span className="section-label">Benefits</span>
          <h2 className="section-title">
            The Key Benefits of AI<br />for Your Business Growth
          </h2>
          <p className="benefits-sub">
            Discover how AI automation enhances efficiency, reduces costs, and drives growth with smarter processes.
          </p>
        </div>

        <div className="benefits-grid" ref={gridRef}>
          {benefits.map((b, i) => (
            <div
              className="benefit-card reveal"
              key={i}
              style={{ transitionDelay: `${i * 0.07}s` }}
            >
              <span className="benefit-num">{b.num}</span>
              <h3 className="benefit-title">{b.title}</h3>
              <p className="benefit-desc">{b.desc}</p>
            </div>
          ))}
        </div>

        <SectionCTA label="If scale is the priority, let's identify the fastest leverage points." />
      </div>
    </section>
  );
}
